import {CONTENT_LOADED, CONTENT_LOADING} from "../actions/actionTypes";


const loaded = (state = {content: null, loaded: false}, action) => {
    switch (action.type) {
        case CONTENT_LOADING:
            return {...state, loaded: action.loaded};
        case CONTENT_LOADED:
            return {...state, content: action.content};
        default :
            return state;

    }
};

export default loaded;



// WEBPACK FOOTER //
// ./src/reducers/loaded.js